import { DialogContent, DialogTitle } from '@mui/material';
import { CloseButton } from './CloseButton';
import { Button } from '@sweep-io/sweep-design';
import { usePromptGroups } from '../usePromptGroups';
import { SinglePrompt } from '../singlePromptDialog/SinglePrompt';

interface PromptsViewProps {
  onClose: () => void;
  onPromptClick: (prompt: string) => Promise<void>;
}

export const PromptsView = ({ onClose, onPromptClick }: PromptsViewProps) => {
  const { unSelectGroup } = usePromptGroups();
  return (
    <>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Button variant="flat-blue" size="small" startIconName="ArrowLeft" onClick={unSelectGroup}>
          All use cases
        </Button>
        <CloseButton onClose={onClose} />
      </DialogTitle>
      <DialogContent sx={{ mt: 2, pb: 3 }}>
        <SinglePrompt onPromptClick={onPromptClick} />
      </DialogContent>
    </>
  );
};
